// extracted by mini-css-extract-plugin
export var container = "_1y-0";
export var disabled = "_1y-4";
export var fullWidth = "_1y-3";
export var lined = "_1y-1";
export var selected = "_1y-5";
export var tab = "_1y-2";